module.exports = __webpack_public_path__ + "img/rec-title-1.9e7a5b9.png";